import React from 'react'
import MuiPopover from '@mui/material/Popover'
import IconButton from '@mui/material/IconButton'

export type MouseHoverProps = {
  /**
   * ポップオーバーで出るコンテンツ
   */
  content: any
  /**
   * クリックするアイコンのコンポーネント
   */
  icon: any
}

const IconPopOver: React.FC<MouseHoverProps> = ({
  content,
  icon,
}: MouseHoverProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return <>
    <IconButton style={{ padding: 0 }} onClick={handleClick} size="large">
      {icon}
    </IconButton>
    <MuiPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {content}
    </MuiPopover>
  </>;
}

export default IconPopOver
